let pageMixin
// eslint-disable-next-line no-undef
if (APPSETTINGS.DataStore.store === 'ichabodcms') {
  pageMixin = {
    computed: {
      itemidDisplay() {
        return `Item ID: ${this.itemid}`
      },
      localTasks() {
        return this.$tore.getters['node/getLocalTasks'](this.item) || []
      },
      show() {
        return Object.keys(this.localTasks).length > 0
      }
    }
  }
}
else {
  pageMixin = {
    computed: {
      itemidDisplay() {
        return `node/${this.itemid}`
      },
      localTasks() {
        if (this.loggedIn) {
          return this.$store.getters['node/getLocalTasks'](this.itemid) || []
        }
        return []
      },
      loggedIn() {
        return this.$store.getters['user/isLoggedIn']
      },
      show() {
        return this.loggedIn && this.localTasks.length
      }
    },
    mounted() {
      this.$store.dispatch('node/generateLocalTasks', {nid: this.itemid, router: this.$router, options: this.options})
    },
    methods: {
      execLocalTask: function(task) {
        if (task.uri !== undefined) {
          this.$router.replace(task.uri)
        }
        else if (task.func !== undefined && typeof task.func === 'function') {
          task.func.call(null, this.item, this.$router)
            .then(_ => this.$store.dispatch('node/generateLocalTasks', {nid: this.itemid, router: this.$router}))
        }
      }
    },
    watch: {
      loggedIn(val) {
        if (val) {
          this.$store.dispatch('node/generateLocalTasks', {nid: this.itemid, router: this.$router, options: this.options})
        }
      }
    }
  }
}

export default pageMixin
export {
  pageMixin
}
